import { utcTimestampToLocalDate } from "@sembark-travel/datetime-utils"
import { TenantBillingDetails, ITenant } from "../../../../../Admin/Tenants"
import { useOutletContext } from "react-router"
import { Required } from "utility-types"
import { Helmet } from "react-helmet-async"

export default function TenantBillingDetailsPage() {
	const { tenant } = useOutletContext<{
		tenant: Required<ITenant, "signup_at">
		refresh: () => void
	}>()
	return (
		<>
			<Helmet>
				<title>Tenant Billings</title>
			</Helmet>
			<TenantBillingDetails
				tenantUid={tenant.uid}
				signupAt={utcTimestampToLocalDate(tenant.signup_at)}
			/>
		</>
	)
}
